import {Component, OnInit} from '@angular/core';
import {SuppliersService} from '../../../../services/suppliers.service';
import {ActivatedRoute} from '@angular/router';
import {map} from 'rxjs/operators';
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  templateUrl: 'pm-project-status.component.html',
  selector: 'pm-project-status',
  styleUrls: ['pm-project-status.component.scss']
})
export class PmProjectStatusComponent implements OnInit {

  currentStatus: ProleisObject;
  previousStatus: ProleisObject;
  status: ProleisObject[];
  index = 0;
  size = 0;
  change = false;

  constructor(private suppliersService: SuppliersService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.suppliersService.getPmProjectStatus(this.route.snapshot.params.id, this.route.snapshot.params.posId).pipe(
      map(result => result.sort((a, b) => {
        if (a.DATE_CREATED < b.DATE_CREATED) {
          return 1;
        } else if (a.DATE_CREATED > b.DATE_CREATED) {
          return -1;
        }
        return 0;
      }))
    ).subscribe(result => {
      this.size = result.length;
      this.status = result;
      this.updateStatus();
    });
  }

  increment() {
    ++this.index;
    this.updateStatus();
  }

  decrement() {
    --this.index;
    this.updateStatus();
  }

  updateStatus() {
    this.currentStatus = this.status[this.index];
    this.previousStatus = this.status[this.index + 1];
  }

  isChanged(field: string) {
    return this.currentStatus[field] !== this.previousStatus[field];
  }

  onValueChange(event) {
    this.change = true;
  }

  createProjectStatus() {
    this.suppliersService.createPmProjectStatus(this.route.snapshot.params.posId).subscribe(result => console.log(result));
  }

  patchProjectStatus() {
    this.suppliersService.patchPmProjectStatus(this.route.snapshot.params.id, this.route.snapshot.params.posId, this.currentStatus).subscribe(result => {
      this.change = false;
    });
  }

}
